import { apiService } from './apiService';

export const offerService = {
  async syncWorkiomOffers() {
    return await apiService.post('/workiom/sync-offers', {});
  },

  async syncWorkiomOffersToBids() {
    return await apiService.post('/workiom/sync-offers-to-bids', {});
  },

  async updateWorkiomOffer(workiomRecordId: string, payload: {
    offerNo?: string;
    offerPrice?: number;
    vehicleArrivalTime?: string;
    tractorPlate?: string;
    trailerPlate?: string;
    driverPhone?: string;
    status?: 'new' | 'approved' | 'rejected';
  }) {
    return await apiService.put(`/workiom/offers/${workiomRecordId}`, payload);
  },

  async getWorkiomOffers(params?: {
    search?: string;
    status?: string;
    page?: number;
    pageSize?: number;
    includeIncomplete?: boolean;
    offeredFrom?: string;
    offeredTo?: string;
    pickupCity?: string;
    deliveryCity?: string;
  }) {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.page) queryParams.append('page', String(params.page));
    if (params?.pageSize) queryParams.append('pageSize', String(params.pageSize));
    if (typeof params?.includeIncomplete === 'boolean') queryParams.append('includeIncomplete', String(params.includeIncomplete));
    if (params?.offeredFrom) queryParams.append('offeredFrom', params.offeredFrom);
    if (params?.offeredTo) queryParams.append('offeredTo', params.offeredTo);
    if (params?.pickupCity) queryParams.append('pickupCity', params.pickupCity);
    if (params?.deliveryCity) queryParams.append('deliveryCity', params.deliveryCity);

    const query = queryParams.toString();
    return await apiService.get(`/workiom/offers${query ? `?${query}` : ''}`);
  },

  async getOffers(params?: { status?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);

    const query = queryParams.toString();
    return await apiService.get(`/offers${query ? `?${query}` : ''}`);
  },

  async getOffer(id: string | number) {
    return await apiService.get(`/offers/${id}`);
  },

  async createOffer(data: any) {
    return await apiService.post('/offers', data);
  },

  async updateOffer(id: string | number, data: any) {
    return await apiService.put(`/offers/${id}`, data);
  },

  async deleteOffer(id: string | number) {
    return await apiService.delete(`/offers/${id}`);
  },
};
